import { AxiosError, AxiosResponse } from 'axios'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import lodash from 'lodash'
import ApiErrorParser from './ApiErrorParser'
import Env from './Env'
dayjs.extend(utc)
dayjs.extend(timezone)

const DEFAULT_NUMBERFORMAT = Intl.NumberFormat('id-ID', { style: 'decimal' })
const CURRENCIES_NUMBERFORMAT: { [k: string]: Intl.NumberFormat } = {
  IDR: Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    currencyDisplay: 'code',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }),
  USD: Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'code',
  }),
  SGD: Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'SGD',
    currencyDisplay: 'code',
  }),
  MYR: Intl.NumberFormat(/*'ms-MY'*/ 'id-ID', {
    style: 'currency',
    currency: 'MYR',
    currencyDisplay: 'code',
  }),
  EUR: Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'code',
  }),
  USDT: Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    currencyDisplay: 'symbol',
  }),
}

const FormatHelper = {
  currency: (currency: string, amount: number): string => {
    return (CURRENCIES_NUMBERFORMAT[currency] ?? DEFAULT_NUMBERFORMAT).format(amount)
  },

  rate: (amount: number): string => {
    return Intl.NumberFormat('en-US', {
      style: 'decimal',
      maximumFractionDigits: 8,
    }).format(amount)
    // return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  },

  amount: (amount: number | undefined, currency: string): string => {
    if (typeof amount === 'undefined') return '-'

    return (CURRENCIES_NUMBERFORMAT[currency] ?? DEFAULT_NUMBERFORMAT).format(amount)
  },

  // numberFormat: (amount:number) => {
  // new Intl.NumberFormat(['en'], {style: 'currency', currency: , currencyDisplay: 'symbol', minimumFractionDigits: 0}).format(amount)
  // },
  humanDate: (date: Date): string => {
    return date ? dayjs(date).tz('Asia/Jakarta').format('LL') : '-'
  },

  humanDateTime: (date: Date): string => {
    return date ? dayjs(date).tz('Asia/Jakarta').format('LL LT') : '-'
  },

  humanDateTimeSecond: (date: Date): string => {
    return date ? dayjs(date).tz('Asia/Jakarta').format('LL LTS') : '-'
  },

  humanDateNumber: (date: Date): string => {
    return date ? dayjs(date).tz('Asia/Jakarta').format('L LT') : '-'
  },

  error: (arg?: null | Error | string | AxiosError | AxiosResponse): string => {
    // if (process.env.NODE_ENV === 'development') console.error(arg)

    if (arg instanceof Object && (arg as AxiosError).response) {
      return new ApiErrorParser(arg).toString()
    }

    if (arg instanceof Error) {
      return arg.message
    } else if (typeof arg === 'string') {
      return arg
    } else {
      return 'error'
    }
  },

  capitalize: (s: string): string => {
    return lodash.capitalize(s)
  },

  maskEmail: (s: string): string => {
    return s.replace(/^(.{2})(.*)(.{2}@.*)$/, (_, a, b, c) => a + b.replace(/./g, '*') + c)
  },

  removeEmptyKeys: (obj: { [key: string]: any }): any => {
    const newObj: any = {}

    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
        newObj[key] = obj[key]
      }
    }

    return newObj
  },
  getFileNameFromUrl: (url: string): string => {
    // Get the part of the URL before the '?'
    const mainPath = url.split('?')[0]

    // Split the path by '/'
    const pathSegments = mainPath.split('/')

    // Return the last segment, which is the filename
    return pathSegments[pathSegments.length - 1]
  },

  getStorageUrl: (url: string): string => {
    return [Env.minioUrl, Env.minioBucket, url].join('/')
  },
}

export default FormatHelper
